// extracted by mini-css-extract-plugin
export default {"btn":"AddToCart_btn__G4ekj","input":"AddToCart_input__wQ9Ri","confirmButton":"AddToCart_confirmButton__hosu5","btnAdd":"AddToCart_btnAdd__-GoMY"};